import { useCallback, useState } from "react";

export type MicAssignments = Record<string, string>;

interface UseMicAllocatorArgs {
  participantIds: string[];
  initialDeviceIds: string[];
}

export const useMicAllocator = ({
  participantIds,
  initialDeviceIds,
}: UseMicAllocatorArgs) => {
  const [micAssignments, setMicAssignments] = useState<MicAssignments>(() => {
    const map: MicAssignments = {};
    participantIds.forEach((pid, index) => {
      if (initialDeviceIds[index]) {
        map[pid] = initialDeviceIds[index];
      }
    });
    return map;
  });

  /**
   * 🔥 NO SWAP
   * Only update selected participant mic
   */
  const assignMic = useCallback((participantId: string, deviceId: string) => {
    setMicAssignments((prev) => ({
      ...prev,
      [participantId]: deviceId,
    }));
  }, []);

  return {
    micAssignments,
    assignMic,
  };
};
